import { LinearProgress } from '@mui/material';

import { PaymentResultPage } from '../../atoms/PaymentResultPage/PaymentResultPage';
import { useFormContext } from '../../../store/formContext';
import { Form } from '../../Form/Form';


const Apply = () => {
  const {
    state: { progress, paymentStatus },
  } = useFormContext();

  if (paymentStatus === 'success') {
    return (
      <PaymentResultPage
        title={"Thank you, We've received your BondPay Application!"}
        subTitle="We are now processing your application"
      />
    );
  }

  if (paymentStatus === 'rejected') {
    return <PaymentResultPage title="Something went wrong, try again" />;
  }

  return (
    <>
      <LinearProgress
        sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1200 }}
        variant="determinate"
        value={progress}
      />
      <Form />
    </>
  );
};

export default Apply;
